import React from 'react';
import styled from 'styled-components';
import SearchIcon from 'components/icons/SearchIcon';
import { ReactComponent as CrossIcon } from 'images/v2/icons/svg/fill/svg/cross.svg';

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  onClear?: () => void;
  disabled?: boolean;
}

const SearchInput: React.FC<Props> = ({ value, onChange, placeholder, onClear, disabled }) => (
  <Wrapper $disabled={disabled}>
    <IconWrapper>
      <SearchIcon />
    </IconWrapper>
    <Input value={value} onChange={onChange} placeholder={placeholder} disabled={disabled} />
    {value && onClear && !disabled && (
      <ClearButton onClick={onClear} aria-label="Clear search">
        <CrossIcon width={14} height={14} />
      </ClearButton>
    )}
  </Wrapper>
);

const Wrapper = styled.div<{ $disabled?: boolean }>`
  height: 40px;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.colors.elementsDropDown};
  border-radius: 4px;
  padding: 11px 0px 12px 14px;
  gap: 10px;
  box-sizing: border-box;
  border: 1.5px solid transparent;
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  &:focus-within {
    background-color: ${(props) => (props.$disabled ? props.theme.colors.elementsDropDown : props.theme.colors.primaryWhite)};
    border-color: ${(props) => (props.$disabled ? 'transparent' : props.theme.colors.primaryOrange)};
  }
`;

const IconWrapper = styled.span`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const Input = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font-family: 'Inter';
  font-size: 14px;
  color: ${(props) => props.theme.colors.primaryBlack};
  width: 100%;
  padding: 0;
  &::placeholder {
    color: ${(props) => props.theme.colors.primaryBlack70};
  }
  &:focus::placeholder {
    color: transparent;
  }
`;

const ClearButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: none;
  border: none;
  padding: 0 10px;
  cursor: pointer;
  color: ${(props) => props.theme.colors.primaryBlack};
  &:hover {
    color: ${(props) => props.theme.colors.primaryOrange};
  }
`;

export default SearchInput;
